<mat-toolbar class="login-toolbar">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Complete Pest - Login</span>
</mat-toolbar>

<div class="login-container">
  <div class="login-content">
    <h2>Sign in to your account</h2>
    <amplify-authenticator [hideSignUp]="true">
      <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
        <div class="auth-success">
          <h3>Welcome back!</h3>
          <p>You are now signed in as {{ user.username }}</p>
          <button mat-raised-button (click)="onAuthSuccess()">
            Continue to Dashboard
          </button>
        </div>
      </ng-template>
    </amplify-authenticator>
  </div>
</div>